// extracted by mini-css-extract-plugin
export default {"defaultbutton":"Subscribe_defaultbutton__06PDo"};